import {MatButtonModule} from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgModule } from '@angular/core';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatIconModule} from '@angular/material/icon';
import {MatCardModule} from '@angular/material/card';
import {MatDividerModule} from '@angular/material/divider';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatTableModule} from '@angular/material/table';
import {MatDialogModule} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import { MatPaginatorModule } from '@angular/material/paginator';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatStepperModule} from '@angular/material/stepper';
import {MatRadioModule} from '@angular/material/radio';
import { MatSortModule } from '@angular/material/sort';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

// This material class is created so we don't clutter our app.module class

@NgModule({
    imports: [MatButtonModule, MatCheckboxModule, MatToolbarModule, MatSidenavModule, MatTooltipModule, MatProgressSpinnerModule,
        MatIconModule, MatCardModule, MatDividerModule, MatExpansionModule, MatButtonToggleModule,
        MatTableModule, MatDialogModule, MatFormFieldModule, MatSelectModule, MatPaginatorModule, MatSlideToggleModule,
        MatSnackBarModule, MatStepperModule, MatRadioModule, MatSortModule],
    exports: [MatButtonModule, MatCheckboxModule, MatToolbarModule, MatSidenavModule, MatTooltipModule, MatProgressSpinnerModule,
        MatIconModule, MatCardModule, MatDividerModule, MatExpansionModule, MatButtonToggleModule, MatSlideToggleModule,
        MatTableModule, MatDialogModule, MatFormFieldModule, MatSelectModule, MatPaginatorModule,
        MatSnackBarModule, MatStepperModule, MatRadioModule, MatSortModule,
    ],
})

export class MaterialModule { }
